import { apiFetchJson } from "@/services/apiClient";
import { API_URL } from "@/lib/utils";

export interface UserProfile {
  emp_grade: string | null;
  emp_dept: string[];
  emp_office: string[];
  emp_dept_permission: string[];
  emp_office_location_permission: string[];
  emp_grade_permission: string[];
  is_employee: boolean;
}

export async function getProfile(userId: string): Promise<UserProfile> {
  return apiFetchJson<UserProfile>(`${API_URL}/user/profile/${userId}`, { method: "GET" });
}
